import { inject } from 'vue';

export function useCoursesExport(filters, searchQuery) {
  const emitter = inject('emitter', null);

  async function exportCourses() {
    try {
      // Show loading indication
      if (emitter) {
        emitter.emit('show-notification', {
          type: 'info',
          message: 'Generating export, please wait...'
        });
      }
      
      // Create URL with any active filters
      let url = 'https://api.kewaar.com/api/admin/courses2/export';
      let params = new URLSearchParams();
      
      // Add current filters to the export
      if (filters.value.status) params.append('status', filters.value.status);
      if (filters.value.category) params.append('category', filters.value.category);
      if (filters.value.instructor) params.append('instructor', filters.value.instructor);
      if (filters.value.type) params.append('type', filters.value.type);
      if (searchQuery.value) params.append('search', searchQuery.value);
      
      // Format: pdf as specified
      params.append('format', 'pdf');
      
      const finalUrl = `${url}?${params.toString()}`;
      
      // Authorization token
      const authToken = localStorage.getItem('token');
      
      // Fetch the PDF file with proper headers
      const response = await fetch(finalUrl, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${authToken}`,
        },
      });
      
      if (!response.ok) {
        throw new Error(`Failed to export courses: ${response.status} ${response.statusText}`);
      }
      
      // Get the file as a blob
      const blob = await response.blob();
      
      // Create object URL for the blob
      const url_object = window.URL.createObjectURL(blob);
      
      // Create a link element to download the file
      const link = document.createElement('a');
      link.href = url_object;
      link.download = `courses_export_${new Date().toISOString().slice(0, 10)}.pdf`;
      document.body.appendChild(link);
      
      // Trigger download
      link.click();
      
      // Clean up
      window.URL.revokeObjectURL(url_object);
      document.body.removeChild(link);
      
      if (emitter) {
        emitter.emit('show-notification', {
          type: 'success',
          message: 'Export completed successfully.'
        });
      }
    } catch (error) {
      console.error('Error exporting courses:', error);
      if (emitter) {
        emitter.emit('show-notification', {
          type: 'error',
          message: 'Failed to export courses. Please try again.'
        });
      }
    }
  }

  return {
    exportCourses
  };
} 